import { defHttp } from '@/axios/http';
import QS from 'qs'

/**
 * 公司用户管理-查询用户
 */
export const selectUser = (data?: any) => {
  // return defHttp.get({ url: '/auth/user/findAll', data });
  return defHttp.post({ url: '/users', data });
};
/**
 * 公司用户管理-導出用户
 */
export const exportUser = (data?: any) => {
  return defHttp.post({ url: '/exportUser', data, responseType: 'blob' });
};
/**
 * 查询该用户所在的公司购买的系统与用户可在新增的角色列表
 */
export const findRoleListByUserId = () => {
  return defHttp.get({ url: '/role/findListByLoginUser' });
};
/**
 * 公司用户管理-新增用户
 */
export const addUser = (data: any) => {
  return defHttp.post({
    url: '/auth/user/add',
    // params,
    data,
    headers: { 'Content-Type': 'application/json;charset=utf-8' },
    // paramsSerializer: function (params:any) {
    //   return QS.stringify(params, { indices: false })
    // }
  });
};
/**
 * 公司用户管理-修改用户
 */
export const updateUser = (data: any) => {
  return defHttp.put({
    url: '/user/update',
    data,
    headers: { 'Content-Type': 'application/json;charset=utf-8' },
    // paramsSerializer: function (params:any) {
    //   return QS.stringify(params, { indices: false })
    // }
  });
};
/**
 * 公司用户管理-删除用户
 */
export const delUser = (data: string[]) => {
  return defHttp.delete({ url: '/user/del', data });
};

/**
 * 公司用户管理 - 新增授权系统与角色
 */
export const addSystemAndRole = (params: any,data: any) => {
  return defHttp.post({
    url: '/systemAndRole/saveOrUpdate',
    params,
    data,
    headers: { 'Content-Type': 'application/json;charset=utf-8' },
    paramsSerializer: function (params:any) {
      return QS.stringify(params, { indices: false })
    }
  });
};
/**
 * 公司用户管理 - 刪除授权系统与角色
 */
export const delSystemAndRole = (params: any,) => {
  return defHttp.delete({url: '/systemAndRole/del',params});
};
/**
 * 获取所有付费公司
 */
export const getCompanyList = () => {
  return defHttp.post({
    url: '/company/list',
  });
};
/**
 * 用户管理-用户详情
 */
export const getUserById = (params?: any) => {
  return defHttp.get({ url: '/user/' + params.id });
};
// 新增系统用户
export const addSystemUser = (data: any) => {
  return defHttp.post({ url: '/user',data },{'rsa_encrypt_show':true});
}; 
/**
 * 用户类型下拉框
 */
export const getUserTypeDown = (params?: any) => {
  return defHttp.get({ url: '/user/type/dropdown'});
};
/**
 * 用户类型分页列表
 */
export const getUserTypeList = (data?: any) => {
  return defHttp.post({ url: '/user/types', data});
};
/**
 * 新增用户类型
 */
export const addUserType = (data?: any) => {
  return defHttp.post({ url: '/user/type', data});
};
/**
 * 编辑用户类型
 */
export const editUserType = (data: any) => {
  return defHttp.put({ url: '/user/type', data });
};
/**
 * 刪除用户类型
 */
export const delUserType = (id: string) => {
  return defHttp.put({ url: '/user/type/' + id });
};
/**
 * 用户类型详情
 */
export const getUserType = (id: string) => {
  return defHttp.get({ url: '/user/type/' + id });
};
/**
 * 解锁账号
 */
export const unlock = (data?: any) => {
  return defHttp.post({ url: '/user/unlock?userId='+data.userId, data});
};
